import React from 'react';

const Code = ({ content }) => {
  return <code className='example'>{content}</code>;
};

export default Code;
